export default __webpack_public_path__ + "271adcaa78d3c9541ed68bfca1056cd6.svg";